module.exports = __webpack_public_path__ + "static/media/land-fire.11b597c1.png";